import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftTaillightProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearLeftTaillight(props: RearLeftTaillightProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Left Taillight"
      width={100}
      height={75}
      viewBox="0 0 100 75"
      position={{right: 36, bottom: 30}}
    >
      <path
        d="M1 74C1.0804 74 1.16141 73.9999 1.24302 73.9996C12.089 68.9783 22.3724 64.1643 28 63C55.0129 57.4112 63.633 46.0269 70 34C72.101 30.0314 75.2595 24.9409 79 18C82.1125 16.5681 84.8615 14.7109 87 13C90.0937 10.525 94.0347 7.2073 98 3C95 28 87 49 78 56C62.2876 68.2207 18.4176 73.9457 1.24302 73.9996C1.24274 73.9997 1.24246 73.9999 1.24219 74H1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M49 56C53 57 61 60 64 63"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M98 3C95 28 87 49 78 56C62.213 68.2788 18 74 1 74H1.24219C12.0885 68.9786 22.3722 64.1644 28 63C55.0129 57.4112 63.633 46.0269 70 34C72.101 30.0314 75.2595 24.9409 79 18C82.1125 16.5681 84.8615 14.7109 87 13C90.0937 10.525 94.0347 7.2073 98 3Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
